import Vue from 'vue';
import Vuex from 'vuex';

import bookShoot from './modules/new-shoot';
import error from './modules/errors';
import infiniteScroll from './modules/infiniteScroll';
import notification from './modules/notifications';
import pkg from './modules/packages';
import resources from './modules/resources';
import services from './modules/services';
import settings from './modules/settings';
import shoot from './modules/shoot';
import stepper from './modules/stepper';
import user from './modules/user';
import alert from './modules/alert';
import downloads from './modules/downloads';
import modal from './modules/modal';
import billing from './modules/billing';
import videoGenerator from './modules/video-generator';
import imagesEditor from './modules/images-editor';
import uploadProgress from './modules/upload-progress';
import dragUpload from './modules/drag-upload';
import deleteConfirmation from './modules/delete-confirmation';
import addLabelDialog from './modules/add-label-dialog';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    bookShoot,
    error,
    infiniteScroll,
    notification,
    pkg,
    resources,
    services,
    settings,
    shoot,
    stepper,
    user,
    alert,
    downloads,
    modal,
    billing,
    videoGenerator,
    imagesEditor,
    uploadProgress,
    dragUpload,
    deleteConfirmation,
    addLabelDialog
  }
});
